import template from './floatingActionButtons.html';
import controller from './floatingActionButtons.controller';
import './floatingActionButtons.scss';

let floatingActionButtonsComponent = {
  restrict: 'E',
  bindings: {
    buttons: '<',
    onClickFirstButton: '&',
    onClickSecondButton: '&',
    isSimulate: '<',
    isChoicesOpen: '<',
    switchColors: '<'
  },
  template,
  controller
};

export default floatingActionButtonsComponent;



// WEBPACK FOOTER //
// ./client/app/components/floatingActionButtons/floatingActionButtons.component.js